import React from 'react';
import ProdutoService from '../services/ProdutoService';
import { Rating } from 'primereact/rating';
import { Button } from 'primereact/button';
import { DataView} from 'primereact/dataview';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { hideProcess, showProcess } from '../utils/utils';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import CarrinhoService from '../services/CarrinhoService';

class Loja extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            produtos: [],
            search: '',
            carrinho: {itens:[]}
        }
    }

    async componentDidMount(){    
        try{

            await showProcess();

            const responseProduto = await ProdutoService.getAll();
            const responseCarrinho = await CarrinhoService.create();

            
            localStorage.setItem("carrinho", JSON.stringify(responseCarrinho.data.object));

            this.setState({carrinho: responseCarrinho.data.object, produtos: responseProduto.data.object});
            

        }catch(e){
            alert(e)
        }
        
        hideProcess();
    }

    gridItem = (product) => {
        return (
            <div className="col-12 sm:col-6 lg:col-4 xl:col-3 p-5" key={product.id}>
                <div className='app-card-produto'>
                    
                    <div className='app-card-produto-imagem'>
                        <img src={product.imagem !== null ? product.imagem : require("../img/no-image.jpeg")} style={{height: '200px', objectFit: 'contain', backgroundColor: '#ffffff'}}/>
                    </div>
                    
                    <br/>
                    
                    <span className="app-card-produto-nome">{product.nome}</span>
                    
                    <br/>

                    <Button label='Comprar' className='app-background-gold' style={{padding: '10px', border: '2px solid #DAA520', marginTop: '20px'}} onClick={() => this.selectProduto(product)}/>
                    
                </div>
            </div>
        );
    };

    itemTemplate = (product) => {
        if (!product) {
            return;
        }
        return this.gridItem(product);
    };

    listTemplate = (products, layout) => {
        return <div className="grid grid-nogutter">{products.map((product, index) => this.itemTemplate(product, layout, index))}</div>;
    };

    selectProduto = (produto) => {
        
        var item = this.state.carrinho.itens.find(i => i.produto.id === produto.id);

        if (item === null || item === undefined){

            item = {
                produto: produto,
                quantidade: 0
            }
            
        }

        console.dir(item)

        this.setState({item: item});
    }

    addItem = async () => {
        try{

            await showProcess();

            if (this.state.item.quantidade > 0){                

                const response = await CarrinhoService.addItem(this.state.item);

                if (response.data.status === "sucess"){

                    localStorage.setItem("carrinho", JSON.stringify(response.data.object));

                    this.setState({carrinho: response.data.object, item: undefined});

                    this.props.refreshState()

                }else{
                    alert(response.data.message);
                }

            } else {

                if (this.state.item.id === undefined){
                    hideProcess();
                    return
                }

                const response = await CarrinhoService.removeItem(this.state.item);

                if (response.data.status === "sucess"){

                    localStorage.setItem("carrinho", JSON.stringify(response.data.object));

                    this.setState({carrinho: response.data.object, item: undefined});

                    this.props.refreshState()

                }else{
                    alert(response.data.message);
                }
                
            }

        }catch(e){
            alert(e)
        }
        
        hideProcess();
    }

    render() {
        return(
            <>
                <div style={{width: '100%', padding: '10px', backgroundColor: '#CB2821'}}>
                    
                    <div className='app-search' style={{margin: '0 auto'}}>
                        <InputText placeholder='Pesquisar...' value={this.state.search} style={{paddingTop: '0px', paddingBottom: '0px'}} onChange={(e) => this.setState({search: e.target.value})}  />
                        <img src={require('../img/icon-pesquisar.png')}/>
                    </div>

                </div>

                <div className="card">
                    <DataView value={this.state.produtos.filter(p => p.nome.toUpperCase().includes(this.state.search.toUpperCase()))} listTemplate={this.listTemplate} layout={this.state.layout} emptyMessage=' ' />
                </div>

                {this.state.item !== undefined && 
                    <Dialog header="" className='app-dialog-produto' style={{maxWidth: '400px'}} visible={true} onHide={() => this.setState({item: undefined})} modal={true}>

                        <span className="app-dialog-produto-nome">{this.state.item.produto.nome}</span>
                        <br/>
                        <img src={this.state.item.produto.imagem !== null ? this.state.item.produto.imagem : require("../img/no-image.jpeg")} style={{height: '200px', objectFit: 'contain', backgroundColor: '#ffffff'}}/>
                        <br/>
                        <br/>
                        <br/>
                        <span>Quantidade</span>
                        <div className='app-dialog-produto-quantidade' style={{borderRadius: '3px', borderColor: 'gray'}}>
                            <Button label='-' className='app-background-gold' style={{fontSize: '20px', fontWeight: 'bold', border: 'none'}} onClick={() => this.setState(prevState  => ({item:{...prevState.item, quantidade: this.state.item.quantidade - 1}}))}/>
                            <InputNumber value={this.state.item.quantidade} 
                                     onChange={e=> this.setState(prevState  => ({item:{...prevState.item, quantidade: e.value}}))} 
                                     buttonLayout="horizontal" 
                                     min={0}
                                     style={{width: 'calc(100% - 80px)'}}
                                     inputStyle={{textAlign: 'center', border: 'none'}}
                                     />
                            <Button label='+' className='app-background-gold' style={{fontSize: '20px', fontWeight: 'bold', border: 'none'}}  onClick={() => this.setState(prevState  => ({item:{...prevState.item, quantidade: this.state.item.quantidade + 1}}))}/>
                        </div>

                        <Button label='Confirmar' className='app-background-gold' style={{padding: '10px', border: '2px solid #DAA520', marginTop: '10px', width: '100%'}} onClick={() => this.addItem()}/>
                        
   
                                
                    </Dialog>
                }
                
            </>
            
        );
        
    }


}
export default Loja;
